import React from "react";

export const LazyEditRoundPage = React.lazy(
  () => import("modules/projectRole/pages/RoundsPage/pages/EditRoundPage"),
);
